<template>
  <div>
    <!-- MATH -->
    <div class="input-group">
      <div class="input-group-addon"><i class="fa-light fa-calculator" aria-hidden="true"></i></div>
      <input type="text" class="form-control" :id="pFieldValueInputId" :name="fieldValueInputName"
             :placeholder="'dictionary.general.undefined' | i18nText(pDictionary)"
             readonly="true" v-model="value">
    </div>
  </div>
</template>

<script>
import BaseMixin from "@/mixins/base-mixin";
import FormMixin from "@/mixins/form-mixin";
import FormatMixin from "@/mixins/format-mixin";

export default {
  name: "FieldValueMathForm",
  mixins: [BaseMixin, FormMixin, FormatMixin],
  props: {
    pFieldValue: {
      type: Object,
      required: true
    },
    pFieldValueInputId: {
      type: String,
      required: true
    },
    pFieldValueInputNamePrefix: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      value: this.pFieldValue.value
    }
  },
  computed: {
    fieldValueInputName: function () {
      return this.pFieldValueInputNamePrefix + ".value";
    },
  }
}
</script>

<style scoped>

</style>